<!--
 * @Author: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-15 17:00:01
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-11-14 10:21:46
 * @FilePath: \fe-crm\src\views\client\components\invoice-list\update-invoice\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="page-comp-clue-new-trip">
    <jw-modal :visible="visible" @ok="handleOk" @cancel="handleCancel" title-align="start" width="500px" :mask-closable="false" unmount-on-close :ok-loading="loading">
      <template #title> {{ title }}</template>
      <jw-form :model="form" label-align="right" auto-label-width ref="invoiceForm" @submit="handleSubmit" class="select-item">
        <jw-form-item field="custom" :label="$t('客户')" asterisk-position="end" :rules="{ required: true, message: $t('请输入客户名称') }" :validate-trigger="['blur', 'input']">
          <jw-input :style="{ width: '320px' }" v-model="form.custom" :placeholder="$t('请输入客户名称')" disabled> </jw-input>
        </jw-form-item>
        <jw-form-item field="invoiceType" :label="$t('抬头类型')" asterisk-position="end" :rules="{ required: true, message: $t('请选择抬头类型') }" :validate-trigger="['blur', 'input']">
          <jw-select v-model="form.invoiceType" :placeholder="$t('请选择抬头类型')" :style="{ width: '320px' }" allow-clear allow-search :options="invoiceType"> </jw-select>
        </jw-form-item>
        <jw-form-item field="invoiceHead" :label="$t('开票抬头')" asterisk-position="end" :rules="{ required: true, message: $t('请输入开票抬头') }" :validate-trigger="['blur', 'input']">
          <jw-input :style="{ width: '320px' }" v-model="form.invoiceHead" :placeholder="$t('请输入开票抬头')"> </jw-input>
        </jw-form-item>
        <jw-form-item field="taxIdCode" :label="$t('纳税识别号')" asterisk-position="end" class="taxpayer">
          <jw-input :style="{ width: '320px' }" v-model="form.taxIdCode" :placeholder="$t('请输入纳税识别号')"> </jw-input>
        </jw-form-item>
        <jw-form-item field="bank" :label="$t('开户银行')" asterisk-position="end">
          <jw-input :style="{ width: '320px' }" v-model="form.bank" :placeholder="$t('请输入开户银行')"> </jw-input>
        </jw-form-item>
        <jw-form-item field="account" :label="$t('开户账号')" asterisk-position="end">
          <jw-input :style="{ width: '320px' }" v-model="form.account" :placeholder="$t('请输入开户账号')"> </jw-input>
        </jw-form-item>
        <jw-form-item field="invoiceAddress" :label="$t('开票地址')" asterisk-position="end">
          <jw-input :style="{ width: '320px' }" v-model="form.invoiceAddress" :placeholder="$t('请输入开票地址')"> </jw-input>
        </jw-form-item>
        <jw-form-item field="comment" :label="$t('备注')" asterisk-position="end">
          <jw-input :style="{ width: '320px' }" v-model="form.comment" :placeholder="$t('请输入备注')"> </jw-input>
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script>
import { reactive, toRefs, inject, ref } from 'vue';
// import { leadsService } from '@/api/';
import { Message } from '@arco-design/web-vue';
// import dayjs from 'dayjs';
import useLoading from '@/hooks/loading';
import { clientService } from '@/api/';
import { useI18n } from 'vue-i18n';
// import { useScheduleStore, useFollowRecords } from '@/store';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'updateInvoice',
  setup(props, ctx) {
    const { t } = useI18n();
    console.log(props, ctx);
    const data = reactive({
      visible: false,
      title: '',
      id: inject('detailParams')?.id, //客户id
      type: inject('detailParams')?.type, //客户id
      record: {},
      from: '', //编辑新增
      invoiceType: [],
      form: {
        customId: '',
        custom: '',
        invoiceType: '',
        invoiceHead: '',
        taxIdCode: '',
        bank: '',
        account: '',
        invoiceAddress: '',
        comment: ''
      }
    });
    const { loading, setLoading } = useLoading(false);
    const invoiceForm = ref();
    const updateInvoiceOpen = (record) => {
      getInvoiceType();
      data.from = record.from;
      data.title = record.title;
      data.visible = true;
      data.form = record.list;
      if (data.from == '1') {
        //新增
      } else {
        //编辑
      }
    };
    // 获取抬头类型
    const getInvoiceType = async () => {
      try {
        const res = await clientService.getInvoiceType({});
        data.invoiceType = res?.result;
      } catch (e) {
        console.log(e);
      }
    };
    // 新建/编辑
    const updateInvoice = async () => {
      setLoading(true);
      try {
        const res = await clientService.saveInvoice(data.form);
        setLoading(false);
        if (res.error) {
          Message.error(res.error?.msg || t('获取数据失败'));
          return;
        } else {
          data.visible = false;
          Message.success(t('操作成功'));
          ctx.emit('cb');
        }
      } catch (e) {
        setLoading(false);
      }
    };
    // 确定按钮
    const handleOk = () => {
      invoiceForm.value.handleSubmit();
    };
    // 表单提交
    const handleSubmit = ({ values, errors }) => {
      console.log('values', values);
      console.log('errors', errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        invoiceForm.value.setFields(errorArray);
        return;
      }
      updateInvoice();
    };
    //  取消按钮
    const handleCancel = () => {
      data.visible = false;
      invoiceForm.value.resetFields(true); //清空表单
    };
    return {
      updateInvoiceOpen,
      handleCancel,
      handleOk,
      handleSubmit,
      invoiceForm,
      loading,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
